module.exports = __webpack_public_path__ + "static/media/24.585916dc.jpeg";